import { render, staticRenderFns } from "./ClubAuthLayout.vue?vue&type=template&id=4ea62e4d"
import script from "./ClubAuthLayout.vue?vue&type=script&lang=js"
export * from "./ClubAuthLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports